import { render, staticRenderFns } from "./RequestItem.vue?vue&type=template&id=c0389d6c&scoped=true"
import script from "./RequestItem.vue?vue&type=script&lang=js"
export * from "./RequestItem.vue?vue&type=script&lang=js"
import style0 from "./RequestItem.vue?vue&type=style&index=0&id=c0389d6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0389d6c",
  null
  
)

export default component.exports